import clsx from 'clsx';
import React, { FC, ReactNode } from 'react';

import styles from './PriceDisplay.module.scss';

export type OutsideTag = 'pre' | 'after';

export interface PriceChange {
  status: 'default' | 'positive' | 'negative';
  change: string;
  proportionChange: string;
}

export interface OutsideHours {
  label: string;
  tag: OutsideTag;
}

export interface PriceDisplayProps {
  price: string | number;
  currency: string;
  priceChange?: PriceChange;
  liveLabel?: string;
  timeNode?: ReactNode;
  isPrimary?: boolean;
  outsideHoursText?: OutsideHours;
  showMarketIndicator?: boolean;
  className?: string;
}

export const PriceDisplay: FC<PriceDisplayProps> = ({
  price,
  currency,
  priceChange,
  liveLabel,
  timeNode,
  outsideHoursText,
  isPrimary = true,
  showMarketIndicator = true,
  className,
  ...rest
}) => (
  <div
    className={clsx(styles.container, className)}
    data-testid="module-price-display"
    data-price-display-wrapper
    {...rest}
  >
    <div
      className={clsx(styles.priceContainer, {
        [styles.isPrimary]: isPrimary,
      })}
      data-price-container
    >
      <div className={styles.priceAndCurrencyContainer}>
        <span className={styles.price} data-price>
          {price}
        </span>
        <span className={styles.currency} data-price-currency>
          {currency}
        </span>
      </div>
      {priceChange && (
        <div
          className={clsx(
            styles.priceChangeContainer,
            styles[priceChange.status]
          )}
          data-testid="price-change"
          data-price-change-container
        >
          <span className={styles.priceChangeLabel}>{priceChange.change}</span>
          <span className={styles.percentageChangeLabel}>
            {priceChange.proportionChange}
          </span>
        </div>
      )}
    </div>
    {showMarketIndicator && (
      <p className={styles.labelsContainer} data-testid="market-status">
        {timeNode}
        {outsideHoursText && (
          <span
            className={clsx(
              styles.outsideHoursTag,
              styles[outsideHoursText.tag]
            )}
          >
            {outsideHoursText.label}
          </span>
        )}
        {liveLabel && <span className={styles.liveLabel}>{liveLabel}</span>}
      </p>
    )}
  </div>
);
